import { render, staticRenderFns } from "./VuseAvatar.vue?vue&type=template&id=c37ec2a6&"
import script from "./VuseAvatar.vue?vue&type=script&lang=js&"
export * from "./VuseAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports